// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Section_elSection__2o5DQ {\n  margin-bottom: 16px;\n  position: relative; }\n\n.Section_cardSection__1Vs3W {\n  margin-top: 0;\n  margin-bottom: 18px;\n  position: relative; }\n\n.Section_loading__1FexC {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  background: #ffffff80;\n  z-index: 2;\n  padding-top: 32px; }\n", ""]);
// Exports
exports.locals = {
	"elSection": "Section_elSection__2o5DQ",
	"cardSection": "Section_cardSection__1Vs3W",
	"loading": "Section_loading__1FexC"
};
module.exports = exports;
